/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigation API
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { BooleanResponse } from '../models';
import { FollowUpFilterRequest } from '../models';
import { FollowUpViewIEnumerableResponse } from '../models';
/**
 * FollowUpApi - axios parameter creator
 * @export
 */
export const FollowUpApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TA All | Returns Follow Ups
         * @param {number} [followUpId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FollowUpApproveRoutineFollowUpPut: async (followUpId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/FollowUp/ApproveRoutineFollowUp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            if (followUpId !== undefined) {
                localVarQueryParameter['followUpId'] = followUpId;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Follow Ups
         * @param {FollowUpFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FollowUpGetFollowUpsPost: async (body?: FollowUpFilterRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/FollowUp/GetFollowUps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Follow Ups
         * @param {number} [followUpId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FollowUpRejectRoutineFollowUpPut: async (followUpId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/FollowUp/RejectRoutineFollowUp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            if (followUpId !== undefined) {
                localVarQueryParameter['followUpId'] = followUpId;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FollowUpApi - functional programming interface
 * @export
 */
export const FollowUpApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TA All | Returns Follow Ups
         * @param {number} [followUpId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FollowUpApproveRoutineFollowUpPut(followUpId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await FollowUpApiAxiosParamCreator(configuration).apiV2FollowUpApproveRoutineFollowUpPut(followUpId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Follow Ups
         * @param {FollowUpFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FollowUpGetFollowUpsPost(body?: FollowUpFilterRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FollowUpViewIEnumerableResponse>> {
            const localVarAxiosArgs = await FollowUpApiAxiosParamCreator(configuration).apiV2FollowUpGetFollowUpsPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Follow Ups
         * @param {number} [followUpId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FollowUpRejectRoutineFollowUpPut(followUpId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await FollowUpApiAxiosParamCreator(configuration).apiV2FollowUpRejectRoutineFollowUpPut(followUpId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FollowUpApi - factory interface
 * @export
 */
export const FollowUpApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary TA All | Returns Follow Ups
         * @param {number} [followUpId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FollowUpApproveRoutineFollowUpPut(followUpId?: number, options?: any): AxiosPromise<BooleanResponse> {
            return FollowUpApiFp(configuration).apiV2FollowUpApproveRoutineFollowUpPut(followUpId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Follow Ups
         * @param {FollowUpFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FollowUpGetFollowUpsPost(body?: FollowUpFilterRequest, options?: any): AxiosPromise<FollowUpViewIEnumerableResponse> {
            return FollowUpApiFp(configuration).apiV2FollowUpGetFollowUpsPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Follow Ups
         * @param {number} [followUpId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FollowUpRejectRoutineFollowUpPut(followUpId?: number, options?: any): AxiosPromise<BooleanResponse> {
            return FollowUpApiFp(configuration).apiV2FollowUpRejectRoutineFollowUpPut(followUpId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FollowUpApi - object-oriented interface
 * @export
 * @class FollowUpApi
 * @extends {BaseAPI}
 */
export class FollowUpApi extends BaseAPI {
    /**
     * 
     * @summary TA All | Returns Follow Ups
     * @param {number} [followUpId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FollowUpApi
     */
    public apiV2FollowUpApproveRoutineFollowUpPut(followUpId?: number, options?: any) {
        return FollowUpApiFp(this.configuration).apiV2FollowUpApproveRoutineFollowUpPut(followUpId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Follow Ups
     * @param {FollowUpFilterRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FollowUpApi
     */
    public apiV2FollowUpGetFollowUpsPost(body?: FollowUpFilterRequest, options?: any) {
        return FollowUpApiFp(this.configuration).apiV2FollowUpGetFollowUpsPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Follow Ups
     * @param {number} [followUpId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FollowUpApi
     */
    public apiV2FollowUpRejectRoutineFollowUpPut(followUpId?: number, options?: any) {
        return FollowUpApiFp(this.configuration).apiV2FollowUpRejectRoutineFollowUpPut(followUpId, options).then((request) => request(this.axios, this.basePath));
    }
}
